/**
 * Pure Pseudo (`ps`) locale mappings — no @calendly/i18n / Locales side effects.
 * Keep these out of `load_locale.js` so widely imported modules (e.g. time_format)
 * do not construct Locales when tests mock `@calendly/i18n` without that export.
 */

/** Moment registers Pseudo as `x-pseudo`; app / I18n use `ps`. */
export const MOMENT_TO_APP_LOCALE = { 'x-pseudo': 'ps' }

/**
 * Global `moment.locale(...)` value for an app locale.
 * Pseudo stays on `en`: `x-pseudo` is invalid for Intl/Luxon, and setting it globally
 * breaks any code that reads `moment.locale()` for those APIs. `loadLocale('ps')` still
 * imports the x-pseudo module for per-call formatting via `momentFormatLocaleFor`.
 */
export const momentLocaleFor = (appLocale) => (
  appLocale === 'ps' ? 'en' : appLocale
)

/** Locale for a single Moment `.locale(...)` format call (Pseudo → x-pseudo). */
export const momentFormatLocaleFor = (appLocale) => (
  appLocale === 'ps' ? 'x-pseudo' : appLocale
)

/** Intl / Luxon-safe locale (Pseudo is not a real BCP-47 locale). */
export const intlLocaleFor = (appLocale) => (
  appLocale === 'ps' ? 'en' : appLocale
)

/**
 * Locale for federated MFEs (CRM / oap_web) that use createI18n without a `ps` loader.
 * Passing `ps` can leave those remotes suspended forever (SafeSuspense → Loader) and
 * invitee cards stuck waiting on contact search after a cold refresh.
 */
export const remoteUserLocaleFor = (appLocale) => {
  if (!appLocale) return appLocale
  if (appLocale === 'ps' || appLocale === 'x-pseudo') return 'en'
  return appLocale
}
